<template>
  <div>
    <el-dialog
      title="店铺动销率提升"
      :visible.sync="visible"
      width="720px"
      append-to-body
      :close-on-click-modal="false"
      custom-class="sales-boost-dialog"
    >
      <div class="boost-body">
        <div class="boost-step">
          <div class="boost-step__head">
            <span class="boost-step__num">1</span>
            <span class="boost-step__title">清理长期无销量商品</span>
          </div>
          <div class="boost-cards">
            <div class="boost-card">
              <div class="boost-card__name">零转化商品A</div>
              <div class="boost-card__sub">0销量</div>
            </div>
            <div class="boost-card">
              <div class="boost-card__name">低效率商品B</div>
              <div class="boost-card__sub">极低曝光</div>
            </div>
            <div class="boost-card">
              <div class="boost-card__name">无效率商品C</div>
              <div class="boost-card__sub">无转化</div>
            </div>
            <div class="boost-card">
              <div class="boost-card__name">滞销商品D</div>
              <div class="boost-card__sub">无热度</div>
            </div>
          </div>
          <el-button class="boost-btn boost-btn--clean" type="danger" round @click="onClean">
            去一键清理
          </el-button>
        </div>

        <div class="boost-step">
          <div class="boost-step__head">
            <span class="boost-step__num">2</span>
            <span class="boost-step__title">绑定店铺抖音号，发布图文</span>
          </div>
          <div class="boost-bind-tip">
            前往抖店后台 → 抖音账号管理 → 绑定抖音号
          </div>
          <div class="boost-bind-warn">
            绑定成功后，每日发布商品并添加商品内图片，将自动触发图文发布，获取海量曝光
          </div>
          <el-button class="boost-btn boost-btn--publish" type="success" round @click="onPublish">
            去发布图文
          </el-button>
        </div>

        <div class="boost-result">
          <div class="boost-result__title">完成以上步骤，预计流量提升效果</div>
          <div class="boost-metrics">
            <div class="boost-metric">
              <div class="boost-metric__val">+48%</div>
              <div class="boost-metric__label">曝光量</div>
            </div>
            <div class="boost-metric">
              <div class="boost-metric__val">+25%</div>
              <div class="boost-metric__label">点击量</div>
            </div>
            <div class="boost-metric">
              <div class="boost-metric__val">+20%</div>
              <div class="boost-metric__label">转化率</div>
            </div>
            <div class="boost-metric">
              <div class="boost-metric__val">+50%</div>
              <div class="boost-metric__label">流量加权</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="text" size="mini" @click="dismissToday">今日不再提醒</el-button>
        <el-button type="primary" size="mini" @click="close">我知道了</el-button>
      </div>
    </el-dialog>

    <LowQualityScheduleDialog v-model="scheduleVisible" @saved="onScheduleSaved" />
    <DouyinBindGuide v-model="bindGuideVisible" />
  </div>
</template>

<script>
import LowQualityScheduleDialog from "@/components/LowQualityScheduleDialog.vue";
import DouyinBindGuide from "@/components/DouyinBindGuide.vue";

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

export default {
  name: "SalesBoostGuide",
  components: { LowQualityScheduleDialog, DouyinBindGuide },
  data() {
    return {
      visible: false,
      scheduleVisible: false,
      bindGuideVisible: false,
    };
  },
  methods: {
    storageKey() {
      const user = this.$api.getUserInfo() || {};
      const uid = user.sub_master_id || user.master_id || "0";
      return `salesBoostGuideDismiss_${todayKey()}_${uid}`;
    },
    tryShow() {
      if (localStorage.getItem(this.storageKey()) === "1") {
        return;
      }
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    dismissToday() {
      localStorage.setItem(this.storageKey(), "1");
      this.close();
    },
    onClean() {
      this.scheduleVisible = true;
    },
    onPublish() {
      this.bindGuideVisible = true;
    },
    onScheduleSaved() {
      /* keep boost dialog open so user can continue step 2 */
    },
  },
};
</script>

<style scoped>
.boost-body {
  padding: 4px 2px 8px;
}
.boost-step {
  margin-bottom: 18px;
  padding: 14px 14px 16px;
  border-radius: 10px;
  background: #fafbfd;
  border: 1px solid #eef2f7;
}
.boost-step__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.boost-step__num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.boost-step__title {
  font-size: 15px;
  font-weight: 650;
  color: #303133;
}
.boost-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 14px;
}
.boost-card {
  padding: 12px 8px;
  text-align: center;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ebeef5;
}
.boost-card__name {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}
.boost-card__sub {
  font-size: 12px;
  color: #909399;
}
.boost-btn {
  width: 100%;
  height: 40px;
  font-size: 15px;
  font-weight: 650;
  letter-spacing: 1px;
  border: none;
}
.boost-btn--clean {
  background: linear-gradient(90deg, #ff6b8a 0%, #f56c6c 100%);
}
.boost-btn--clean:hover,
.boost-btn--clean:focus {
  background: linear-gradient(90deg, #ff7a96 0%, #f78989 100%);
}
.boost-btn--publish {
  background: linear-gradient(90deg, #67c23a 0%, #85ce61 100%);
}
.boost-btn--publish:hover,
.boost-btn--publish:focus {
  background: linear-gradient(90deg, #85ce61 0%, #95d475 100%);
}
.boost-bind-tip {
  margin-bottom: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: 600;
}
.boost-bind-warn {
  margin-bottom: 14px;
  font-size: 12px;
  line-height: 1.6;
  color: #f56c6c;
}
.boost-result {
  margin-top: 4px;
  padding: 14px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5f9ff 0%, #fff 100%);
  border: 1px solid #d9ecff;
}
.boost-result__title {
  text-align: center;
  font-size: 13px;
  font-weight: 650;
  color: #606266;
  margin-bottom: 12px;
}
.boost-metrics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.boost-metric {
  text-align: center;
}
.boost-metric__val {
  font-size: 20px;
  font-weight: 700;
  color: #409eff;
  line-height: 1.2;
}
.boost-metric__label {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}
.dialog-footer {
  text-align: right;
}
</style>
